<style scoped>
[contenteditable]:focus {
  outline: 0px solid transparent;
}

.tab-sheet {
  font-size: 10px;
  border-top: 0.5px solid #ccc;
  border-right: 0.5px solid #ccc;
  width: 100%;
  cursor: pointer;
}

.tab-sheet.active {
  border-top: 0;
}

.tab-sheet .text {
  padding: 5px 20px 5px 20px;
}

.bottom-nav {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  background-color: #fff;
}

.bottom-nav div {
  display: block;
  float: left;
  width: auto;
  cursor: pointer;
}

.spread-sheet {
  margin-bottom: 30px;
}

.sticky-menu {
  position: fixed;
  left: 0px;
  top: 0px;
  width: auto;
  z-index: 80;
  height: 50px;
  border-bottom: 0px solid #ccc;
  background-color: #fff;
}

.menu-container {
  position: fixed;
  left: 50px;
  top: 64px;
  width: 250px;
  height: 100%;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 0.9);
  border-right: 0px solid #ccc;
  font-size: 10px;
}

.menu-container .v-input {
  font-size: 10px !important;
}

.canvas-inner {
  height: inherit;
  width: 100%;
  /**background-image: linear-gradient(-225deg, #231557 0%, #44107A 29%, #FF1361 67%, #FFF800 100%);**/
  overflow: hidden;
}

.vue-grid-item {
  /**outline: 1px dashed rgba(170, 170, 170, 0.7);**/
  outline-offset: 0px;
}

.vue-grid-item:hover {
  outline: 0px solid #3b97e3 !important;
}

.layer-editor {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.layer-editor.active {
  border: 0px solid #ccc;
}
</style>
<style>
.vue-grid-item {
  /* transition: all 200ms ease; */
  transition: none;
}

.vue-grid-layout {
  /* transition: height 200ms ease; */
  transition: none;
}
.refresh-button {
  color: #fff;
  cursor: pointer;
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
@-webkit-keyframes blink {
  50% {
    opacity: 0;
  }
}
.blink {
  animation: blink 1s step-start 0s infinite;
  -webkit-animation: blink 1s step-start 0s infinite;
}
.v-dialog--fullscreen {
  background: #fff;
}
.layout-container {
  background: #fff;
}
</style>
<style>
.layout-container.edit-mode .layer-editor {
  border: 1px dashed #ccc;
}


</style>
<template>
  <div>
    <div
      ref="printMe"
      :style="chart.breakpoint.style"
      :class="mode != 'view'  ? 'edit-mode layout-container' : 'layout-container'"
    >
      <v-container
        fluid
        fill-height
        class=""
        style="
          padding-top: 0px;
          padding-left: 0px;
          padding-right: 0px;
          overflow-y: auto;
          padding-bottom: 0px;
          margin-bottom: 0px;
        "
      >
        <v-layout class="mb-0" row wrap justify-start align-left text-xs-left>
          <template
            v-if="
              chart &&
              chart.parameters &&
              chart.parameters.layoutTemplate != null &&
              chart.parameters.layoutTemplate.value == 'top-links'
            "
          >
            <v-toolbar :color="chart.theme.toolbar.backgroundColor" class="taybull-layout-toolbar">
              <span class="refresh-button" v-on:click="aSet(chart)"
                ><v-icon color="white">refresh</v-icon> &nbsp;&nbsp;</span
              >
              <img
                v-if="chart.parameters.logo.value"
                class="mr-3"
                :src="chart.parameters.logo.value"
                height="25"
                :style="chart.parameters.logoStyle.value"
              />
              <v-spacer></v-spacer>
              <v-toolbar-items
                class="hidden-sm-and-down"
                v-if="chart.parameters.layoutLinks.value.length"
              >
                <template
                  v-if="chart.parameters.layoutLinks.value.includes(item.id)"
                  v-for="item in charts"
                >
                  <v-btn
                    flat
                    :key="item.id"
                    v-on:click="aCleanSet(item)"
                    :color="chart.theme.toolbar.fontColorActive"
                    v-if="chart.id == item.id"
                    class="active-link"
                    :style="{
                      borderBottom:
                        '5px solid ' + chart.theme.toolbar.borderColorActive,
                      backgroundColor:
                        chart.theme.toolbar.backgroundColorActive,
                    }"
                    >{{ item.name }}</v-btn
                  >
                  <v-btn
                    flat
                    :key="item.id"
                    v-on:click="aCleanSet(item)"
                    :color="chart.theme.toolbar.fontColor"
                    v-else
                    class="inactive-link"
                    >{{ item.name }}</v-btn
                  >
                </template>
                <div style="width: 70px"></div>
              </v-toolbar-items>
              <v-toolbar-items class="hidden-sm-and-down" v-else>
                <template v-for="item in charts">
                  <v-btn
                    :key="item.id"
                    flat
                    v-on:click="aCleanSet(item)"
                    :color="chart.theme.toolbar.fontColorActive"
                    v-if="chart.id == item.id"
                    class="active-link"
                    :style="{
                      borderBottom:
                        '5px solid ' + chart.theme.toolbar.borderColorActive,
                      backgroundColor:
                        chart.theme.toolbar.backgroundColorActive,
                    }"
                    >{{ item.name }}</v-btn
                  >
                  <v-btn
                    :key="item.id"
                    flat
                    v-on:click="aCleanSet(item)"
                    :color="chart.theme.toolbar.fontColor"
                    v-else
                    class="inactive-link"
                    >{{ item.name }}</v-btn
                  >
                </template>
                <div style="width: 70px"></div>
              </v-toolbar-items>
            </v-toolbar>
          </template>
          <v-flex
            xs12
            sm12
            fill-height
            v-resize="onResize"
            ref="layoutContainer"
            
          >
          <!-- :style="chart.parameters.style ? chart.parameters.style.value : ''" -->
            <div
              class="canvas-inner"
              v-if="chart && chart.layout && chart.layout.grids && display"
            >
              <grid-layout
                v-if="chart.layout.grids"
                :layout.sync="chart.layout.grids"
                :col-num="chart.layout.colNum"
                :row-height="chart.layout.rowHeight"
                :is-draggable="editable"
                :is-resizable="editable"
                :is-mirrored="false"
                :vertical-compact="true"
                :margin="chart && chart.parameters.layoutMargin && chart.parameters.layoutMargin.value ? chart.layout.margin : [0, 0]"
                :use-css-transforms="false"
                :responsive="false"
                @layout-ready="layoutReadyEvent"
              >
                <grid-item
                  :key="index"
                  v-for="(item, index) in chart.layout.grids"
                  :x="item.x"
                  :y="item.y"
                  :w="item.w"
                  :h="item.h"
                  :i="item.i"
                  :item.active="false"
                  @resized="aResized"
                >
                  <div
                    :rowHeight="chart.layout.rowHeight"
                    :h="item.h"
                    v-bind:class="[
                      item.id == activeGrid.id ? 'active' : '',
                      'layer-editor',
                    ]"
                    v-on:mouseover="aActivateGrid(item, true)"
                  >
                    <Layers v-bind:grid="item" v-bind:mode="mode" v-if="ready" />
                  </div>
                </grid-item>
              </grid-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
// import Layers from '@/components/Layers.vue';
const Layers = () => import("@/components/Layers.vue");
import VueGridLayout from "vue-grid-layout";
// const VueGridLayout = () => import('vue-grid-layout');
import { deleteProject } from "@/models/project";

import { createNamespacedHelpers } from "vuex";

const chartNamespace = createNamespacedHelpers("charts");

export default {
  name: "TaybullLayout",
  props: ["chart", "row", "mode"],
  data: function () {
    return {
      ready: false,
      projectId: null,
      dialogDeleteDashboard: false,
      dialogDeleteProject: false,
      output: null,
      d: true,
      menuOpen: false,
      fullscreen: false,
      snackbar: false,
      y: "top",
      x: null,
      timeout: 6000,
      text: "Updated",
    };
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    Layers,
  },
  computed: {
    ...chartNamespace.mapState({
      display: (state) => state.display,
      dialog: (state) => state.dialog,
      showGridMenu: (state) => state.showGridMenu,
      activeGrid: (state) => state.activeGrid,
      activeLayer: (state) => state.activeLayer,
      editable: (state) => state.editable,
      loading: (state) => state.loading,
      progressValue: (state) => state.progressValue,
      theme: (state) => state.theme,
      charts: (state) => state.charts,
    }),
  },
  methods: {
    ...chartNamespace.mapMutations([
      "mSetEditable",
      "mInitializeGrids",
      "mToggleGridMenu",
      "mSetDialog",
      "mAdd",
      "mSetProjectId",
      "mSetTypeGroup",
      "mSet",
      "mSetName",
      "mToggleEditable",
    ]),
    ...chartNamespace.mapActions([
      "aCreateRandomDashboard",
      "aAdd",
      "aInit",
      "aUpdate",
      "aSet",
      "aCleanSet",
      "aDelete",
      "aResized",
      "aAddGrid",
      "aActivateGrid",
    ]),
    layoutReadyEvent() {
      // alert('ready');
      this.ready  = true;
    },
    updateName: function (event) {
      this.mSetName(event.target.innerText);
    },
    toggle() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    notify(text) {
      this.text = text;
      this.snackbar = true;
    },
    async print() {
      // this.output = await this.$html2canvas(el, options);
    },
    async deleteProject() {
      await deleteProject(this.$route.params.projectId);
      this.$router.push({
        name: "projects-home",
      });
    },
    onResize() {
      // let width = this.$refs.layoutContainer.clientWidth;
      // console.log("layout resized", this.$refs);
      // console.log("breakpoint", this.chart.getBreakpointUsingWidth(width));
    },
  },
  createRandomDefault() {},
  mounted: function () {
    // console.log("layoutMounted");
    if (this.mode == "view") {
      this.mSetEditable(false);
    }
    // this.aLoad(chart);

    // this.timeout = setTimeout(function(){
    //             window.dispatchEvent(new Event('resize'));
    //         }, 50);

    // this.mInitializeGrids(this.chart);
  },
  destroyed() {
    // clearTimeout(this.timeout);
  },
  beforeCreate: function () {},
};
</script>
